import { cn } from "@/shared/lib/cn";

interface SkeletonProps {
  className?: string;
  /** Lu par les lecteurs d'écran pendant le chargement. */
  label: string;
}

/**
 * Squelette de chargement plutôt qu'un spinner plein écran : la mise en page ne
 * bouge pas à l'arrivée des données (docs/24 §3, pas de layout shift).
 */
export function Skeleton({ className, label }: SkeletonProps) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-live="polite"
      className={cn("animate-pulse rounded bg-slate-200 dark:bg-slate-800", className)}
    >
      <span className="sr-only">{label}</span>
    </div>
  );
}
